module.exports = __webpack_public_path__ + "img/select-card.48accdc3.png";